__turbopack_context__.v({
  "sideBlock": "A1En-q_sideBlock",
  "sideBlockCollapsed": "A1En-q_sideBlockCollapsed",
  "sideBlockHead": "A1En-q_sideBlockHead",
  "sideBlockHeadCollapsed": "A1En-q_sideBlockHeadCollapsed",
  "sideBlockMenuItemWrapper": "A1En-q_sideBlockMenuItemWrapper",
  "sideBlockMenuItemWrapperActive": "A1En-q_sideBlockMenuItemWrapperActive",
  "toggleWrapper": "A1En-q_toggleWrapper",
});
